import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { useAlert, types } from 'react-alert';
import { ConfirmDialog, VerticalHeadTable, PaperWithTitle, PagingTable, GoogleMap } from '../../components';
import { useMaster, useApplyClinic } from '../../../model/hooks';
import { DateHelper } from '../../../common/helper';
import { getLabelApprovalStatus } from '../../common/helper';
export const ApplyList = () => {
    var _a;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const { master } = useMaster();
    const { loading, columns, loadClinicApplicationList, executeUnapprovedClinic, executeApprovedClinic, } = useApplyClinic();
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [rows, setRows] = useState([]);
    const [row, setRow] = useState();
    const [applyData, setApplyData] = useState([]);
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const onClickDetail = (id) => {
        var _a, _b, _c;
        const row = rows.find((item) => item.id === id);
        setApplyData([
            { th: t('契約者名'), td: row.corporateName },
            { th: t('施設名'), td: row.facilityName },
            { th: t('施設区分'), td: row.facilityDiv },
            { th: t('姓'), td: row.detail.lastNameOfRecruiter },
            { th: t('名'), td: row.detail.firstNameOfRecruiter },
            { th: t('電話番号'), td: row.detail.tel },
            { th: t('メールアドレス'), td: row.detail.email },
            { th: t('都道府県'), td: (_c = (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.prefectureList) === null || _b === void 0 ? void 0 : _b.find((d) => d.id === row.detail.prefectureId)) === null || _c === void 0 ? void 0 : _c.text },
            { th: t('市区町村番地'), td: row.detail.locationAddress },
        ]);
        setRow(row);
        setLat(row.lat);
        setLng(row.lng);
        setIsOpenDialog(true);
    };
    const onCloseDialog = () => setIsOpenDialog(false);
    const onClickNegative = async () => {
        try {
            if (row === undefined)
                return;
            await executeUnapprovedClinic(row.detail.id);
            row.detail.isApproval = false;
            rows[rows.findIndex((item) => item.id === row.id)] = row;
            setRows(rows);
            setIsOpenDialog(false);
            reactAlert.show(t('name の申し込みを否認しました。', { name: row.corporateName }), { type: types.SUCCESS });
        }
        catch (e) {
            if (e instanceof Error) {
                setIsOpenDialog(false);
                reactAlert.show(e.message, { type: types.ERROR });
            }
        }
    };
    const onClickPositive = async () => {
        try {
            if (row === undefined)
                return;
            await executeApprovedClinic(row.detail.id);
            row.detail.isApproval = true;
            rows[rows.findIndex((item) => item.id === row.id)] = row;
            setRows(rows);
            setIsOpenDialog(false);
            reactAlert.show(t('name の申し込みを承認しました。', { name: row.corporateName }), { type: types.SUCCESS });
        }
        catch (e) {
            if (e instanceof Error) {
                setIsOpenDialog(false);
                reactAlert.show(e.message, { type: types.ERROR });
            }
        }
    };
    const loadData = async (lastDocument) => {
        const result = await loadClinicApplicationList(lastDocument);
        return result.data.map((item) => {
            var _a, _b, _c;
            return {
                id: item.id,
                applyDate: DateHelper.toString(item.createdAt.toDate()),
                corporateName: item.corporateName,
                facilityName: item.clinicName,
                facilityDiv: (_c = (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.facilityList) === null || _b === void 0 ? void 0 : _b.find((d) => d.id === item.facilityId)) === null || _c === void 0 ? void 0 : _c.text,
                status: getLabelApprovalStatus(t, item.isApproval),
                detail: item,
                lat: item.latitude,
                lng: item.longitude,
            };
        });
    };
    const onClickExpandMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    useEffect(() => {
        if (!master)
            return;
        const f = async () => {
            try {
                const _rows = await loadData();
                setRows(_rows);
            }
            catch (e) {
                if (e instanceof Error) {
                    reactAlert.show(e.message, { type: types.ERROR });
                }
            }
        };
        f();
    }, [master]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SContainer, null,
            React.createElement(SGrid, { container: true },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(PaperWithTitle, { title: "\u7533\u8ACB\u4E00\u89A7" },
                        React.createElement(PagingTable, { columns: columns, rows: rows, onClickDetailButton: onClickDetail, onClickExpandMore: onClickExpandMore }))))),
        React.createElement(ConfirmDialog, { isOpen: isOpenDialog, title: t('申込内容詳細'), negativeLabel: t('否認'), positiveLabel: t('承認'), onClose: onCloseDialog, onClickNegative: onClickNegative, onClickPositive: onClickPositive, loading: loading, disabled: ((_a = row) === null || _a === void 0 ? void 0 : _a.status) !== '' },
            React.createElement(VerticalHeadTable, { data: applyData }),
            React.createElement(GoogleMap, { lat: lat, lng: lng, disabled: false, draggable: false }))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SContainer = styled.div `
  min-height: 92vh;
  padding-left: 48px;
  padding-right: 48px;
  padding-top: 32px;
`;
